import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/schedulerGroups', request)
}

export {get}
